




























































import { Component, Watch } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import CreateDepartmentRequest from '@/models/Departments/CreateDepartmentRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import DepartmentDto from '@/models/Departments/DepartmentDto';

@Component({
    name: 'LocationDepartmentCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new DepartmentDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new DepartmentDto();
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateDepartmentRequest()
    request.name = this.entity.name;
    request.arrivalInstructions = this.entity.arrivalInstructions
    await LocationDetailsModule.createDepartment(request)
    this.dialog = false;
  }
}
